import axios from 'axios';

import { buildURL } from '../../webservice';

const BASE_URL = process.env.REACT_APP_PAYMENTS_API_URL as string;

export const getBanks = async ({ token }: { token: string }) => {
    try {
        const url = buildURL(BASE_URL, '/v2/banks');
        const response = await axios.get(url, {
            headers: { Authorization: `Bearer ${token}` },
        });

        return response.data;
    } catch (err) {
        console.error('Error getting banks', err);
        return [];
    }
};
